import React from "react";

export default function ContactCardsSection() {
  return (
    <>
      <style>{`
        .fade-card {
          opacity: 0;
          transform: translateY(20px);
          animation: fadeUp 0.8s ease forwards;
        }
        .fade-card:nth-child(2) { animation-delay: 0.15s; }
        .fade-card:nth-child(3) { animation-delay: 0.3s; }
        .fade-card:nth-child(4) { animation-delay: 0.45s; }

        @keyframes fadeUp {
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>

      <section className="max-w-6xl mx-auto px-6 py-12">

        <h2 className="text-3xl font-copperplate text-[#785f14] text-center mb-10">
Ways to reach us
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">

          {/* Email Card */}
          <div className="fade-card bg-white shadow-md rounded-xl p-6 border border-gray-200 hover:shadow-lg transition">
            <h3 className="text-lg font-semibold text-gray-900">Email</h3>
            <p className="mt-2 text-gray-600">
              <a
                href="mailto:contact@savvytron.com"
                className="text-[#785f14] hover:underline"
              >
                contact@savvytron.com
              </a>
            </p>
          </div>

          {/* Phone Card */}
          <div className="fade-card bg-white shadow-md rounded-xl p-6 border border-gray-200 hover:shadow-lg transition">
            <h3 className="text-lg font-semibold text-gray-900">Phone</h3>
            <p className="mt-2 text-gray-600">
              <a 
                href="tel:9402090903" 
                className="text-[#785f14] hover:underline"
              >
                940-209-0903
              </a>
            </p>
          </div>



          {/* Hours Card */}
          <div className="fade-card bg-white shadow-md rounded-xl p-6 border border-gray-200 hover:shadow-lg transition">
            <h3 className="text-lg font-semibold text-gray-900">Business Hours</h3>
            <p className="mt-2 text-gray-600">
              Mon–Sat  
              <br />
              <span className="text-[#785f14]">10 AM – 6 PM</span>
            </p>
          </div>

        </div>
      </section>
    </>
  );
}
